import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { map, Observable, Subject, takeUntil } from 'rxjs';
import { TableDataKey } from '../../types/table-data-key';
import { TableCurrentPageRowsSelectionDirective } from '../../directives/table-current-page-rows-selection.directive';

@Component({
  selector: 'app-table-body-current-page-row-selection-checkbox',
  imports: [CommonModule, CheckboxModule, FormsModule],
  templateUrl:
    './table-body-current-page-row-selection-checkbox.component.html',
  styleUrls: [
    './table-body-current-page-row-selection-checkbox.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableBodyCurrentPageRowSelectionCheckboxComponent<
  Item,
  Filter,
  ItemAction,
  CollectionAction,
  Action,
>
  implements OnDestroy, OnInit
{
  private readonly tableRowsSelection = inject<
    TableCurrentPageRowsSelectionDirective<
      Item,
      Filter,
      ItemAction,
      CollectionAction,
      Action
    >
  >(TableCurrentPageRowsSelectionDirective);

  @Input() public disabled!: boolean;
  @Input() public model!: Item;
  @Input() public dataKey!: TableDataKey<Item>;

  public readonly isChecked$: Observable<boolean>;

  private readonly destroy$ = new Subject<void>();

  public constructor() {
    this.isChecked$ = this.isCheckedSource();
  }

  public ngOnInit(): void {
    this.listenToSelectAllEvent();
    this.listenToDeselectAllEvent();
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
  }

  public handleSelectionChange(isSelected: boolean): void {
    isSelected
      ? this.tableRowsSelection.select(this.model)
      : this.tableRowsSelection.deselect(this.model);
  }

  private listenToDeselectAllEvent(): void {
    this.tableRowsSelection.deselectAll$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.tableRowsSelection.deselect(this.model);
      });
  }

  private listenToSelectAllEvent(): void {
    this.tableRowsSelection.selectAll$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        console.log('test');
        this.tableRowsSelection.select(this.model);
      });
  }

  private isCheckedSource(): Observable<boolean> {
    return this.tableRowsSelection.selectionChanges$.pipe(
      map(() => this.isChecked()),
    );
  }

  private isChecked(): boolean {
    return this.tableRowsSelection.isSelected(this.model);
  }
}
